import localStorageService from "./localStorageService";
import axios from "axios";
import { Get } from "../views/chamada/ChamadaServices";

export const STARTING = "STARTING";
export const STOPPED = "STOPPED";
export const RUNNING = "RUNNING";

const segundos = (valor) => {
  return valor * 1000;
};
const minutos = (valor) => {
  return valor * 1000 * 60;
};

export const ChamadaService = (dispatch) =>
  new Promise((resolve, reject) => {
    dispatch({
      type: STARTING,
    });

    const bgService = setInterval(() => {
      callWebService();
    }, minutos(10));

    const callWebService = () => {
      Get(new Date()).then((retorno) => {
        const { data } = retorno;

        dispatch({
          type: RUNNING,
          data,
        });
      });
    };

    const stopChamada = () => {
      dispatch({
        type: STOPPED,
      });

      clearInterval(bgService);
    };

    callWebService();

    resolve(stopChamada);
  });
